import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import EditableInput from '../../components/EditableInput';
import EditableSelect from './../../components/EditableSelect';
import UneditableInput from '../../components/UneditableInput';

import { updateSubscriber, getSubscriberBySearch } from '../../services/subscribers';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress, Button } from '@material-ui/core';
import { Save } from '@material-ui/icons';

const SubscriptionInformation = props => {
  const dispatch = useDispatch();
  const [subscription, setSubscription] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displaySubscription();
  }, []);

  const displaySubscription = async () => {
    const subscriptionUid = props.match.params.uid;

    try {
      setIsLoading(true);
      const { data } = await getSubscriberBySearch('uid', subscriptionUid);

      setSubscription(data.rows[0]);

      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', 'Ops! We could not load this Subscription. 😔'));
      console.log(error);
    }
  };

  const handleUpdate = async e => {
    e.preventDefault();

    try {
      await updateSubscriber(subscription.id, subscription);

      dispatch(showAlert('success', 'Subscription has been updated! 🔥'));
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not update the Subscription. 😔'));
      console.log(error);
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>Subscription: {subscription?.email}</h1>
      </div>

      <section className="update-section">
        <form onSubmit={handleUpdate} className="update-form">
          <div className="form-fields">
            <EditableInput
              data={subscription}
              setData={setSubscription}
              labels={['name', 'email', 'origin', 'utm', 'utmSource', 'utmMedium', 'utmCampaign', 'utmTerm', 'utmContent', 'utmId']}
            />
            <EditableSelect data={subscription} setData={setSubscription} labels={['isMember', 'enabled', 'isFromLoop', 'isImported']} />
            <EditableSelect data={subscription} setData={setSubscription} labels={['unsubscribedAt', 'blacklistedAt']} isDeletedAt />
            <UneditableInput
              data={subscription}
              labels={['unsubscribedAt', 'blacklistedAt', 'id', 'uid', 'channelId', 'userId', 'cardsToken', 'createdAt', 'updatedAt']}
            />
          </div>
          <Button type="submit" className="update-btn" variant="contained" startIcon={<Save />}>
            Update subscription
          </Button>
        </form>
      </section>
    </>
  );
};

export default SubscriptionInformation;
